import { render, staticRenderFns } from "./m-article-with-image.vue?vue&type=template&id=ff7e4a90&scoped=true"
import script from "./m-article-with-image.vue?vue&type=script&lang=js"
export * from "./m-article-with-image.vue?vue&type=script&lang=js"
import style0 from "./m-article-with-image.vue?vue&type=style&index=0&id=ff7e4a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7e4a90",
  null
  
)

export default component.exports